import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import QCXAutocompleteSelect from '../../../../../../shared-components/autocomplete-select/QCXAutocompleteSelect';

export default function PrestadorAutocomplete({ name, disabled, initialValues = {}, ...restProps }) {
  // prestador-options.js
  const PRESTADORES = [
    { id: 'Agente Carga', description: 'Agente Carga' },
    { id: 'Terminal/Armazém', description: 'Terminal/Armazém' },
    { id: 'Despachante Aduaneiro', description: 'Despachante Aduaneiro' },
    { id: 'Transporte Rodoviário - Entrega', description: 'Transp. Rodoviário ‑ Entrega' },
    { id: 'outros', description: 'Outros' },
  ];

  const { t } = useTranslation();
  const [defaultValue, setDefaultValue] = useState(null);

  /* pega valor inicial se vier pelo Form */
  useEffect(() => {
    const escolhido = PRESTADORES.find((p) => p.id === _.get(initialValues, name));
    setDefaultValue(escolhido ?? null);
  }, [initialValues, name]);

  const getOptionLabel = useCallback((opt) => opt.description, []);
  const getOptionValue = useCallback((opt) => opt.id, []);

  return (
    <QCXAutocompleteSelect
      id={name}
      name={name}
      label="PRESTADOR"
      options={PRESTADORES}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      autoComplete={false}
      autoHighlight={false}
      blurOnSelect
      disableClearable
      disabled={disabled}
      {...restProps}
    />
  );
}
